module.exports = __webpack_public_path__ + "static/media/beginning_of_lesson.af60cd1c.svg";